import { MenuItem, Paper, Select, Stack, Typography } from "@mui/material";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import type { InvestorsPermissionSet } from "../../../store/state/user/types";

interface Props {
  selectedId: string;
  investors: InvestorsPermissionSet[];
  onChange: (investorId: string) => void;
}

const InvestorsMenuSelect = ({ selectedId, investors, onChange }: Props) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, bgcolor: "background.grey" }}>
      <Stack spacing={0.5}>
        <Typography variant="subtitle2" sx={{ pb: 1 }}>
          Investor
        </Typography>

        <Select
          value={selectedId}
          onChange={({ target }) => onChange(target.value)}
          sx={{ width: "100%", bgcolor: "background.paper" }}
          MenuProps={{ sx: { maxWidth: "25rem" } }}
          inputProps={{ "aria-label": "Investor" }}
        >
          {investors.map((investor) => (
            <MenuItem key={investor.investorId} value={investor.investorId} sx={{ whiteSpace: "normal" }}>
              {investor.investorTitle}
            </MenuItem>
          ))}
        </Select>

        <Typography variant="caption" color="textSecondary" sx={{ textAlign: "center" }}>
          You have access to {investors.length} {pluralize("investor", investors.length)}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default InvestorsMenuSelect;
